import React, { useEffect } from "react";
import styles from "./legal_info.module.css";
import { SHOP_NAME, COMPANY_SELLER } from "../../utils/constants";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { Link, useLocation } from "react-router-dom";
import { getDataFromRoutes } from "../../utils/util_functions";
import { setMetaTags } from "../../utils/util_functions";
import { useDispatch } from "react-redux";
import { ROUTES_CONST } from "../../utils/constants";


const Agreement = () => {


  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle);
    // eslint-disable-next-line
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  return (
    <main className="main">
      <h1 className="title">
        {title}
      </h1>
      <p className={styles.text}>
        Настоящее Соглашение определяет условия использования Пользователями
        материалов и сервисов сайта&ensp;
        <Link to='/' className={styles.link}>
          {SHOP_NAME}
        </Link>
        &ensp;(далее — «Сайт»).
      </p>
      <ol className={styles.list_outer}>
        <li className={styles.item_outer}>
          Общие условия
          <ol className={styles.list}>
            <li className={styles.item}>
              Использование материалов и сервисов Сайта регулируется нормами
              действующего законодательства Российской Федерации.
            </li>
            <li className={styles.item}>
              Получая доступ к материалам Сайта Пользователь считается
              присоединившимся к настоящему Соглашению.
            </li>
            <li className={styles.item}>
              Администрация Сайта вправе в любое время в одностороннем
              порядке изменять условия настоящего Соглашения. Такие изменения
              вступают в силу по истечении 3 (Трех) дней с момента размещения
              новой версии Соглашения на сайте. При несогласии Пользователя с
              внесенными изменениями он обязан отказаться от доступа к Сайту,
              прекратить использование материалов и сервисов Сайта.
            </li>
            <li className={styles.item}>
              Администрация
              Сайта вправе ограничить доступ к Сайту в случае нарушения Пользователем
              условий настоящего Соглашения.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Определение терминов
          <ol className={styles.list}>
            <li className={styles.item}>
              Перечисленные ниже термины имеют для целей настоящего Соглашения
              следующее значение:
              <ol className={styles.list}>
                <li className={styles.item}>
                  Сайт- содержит информацию о Товарах, Продавце, позволяющий
                  осуществить ознакомление с Товаром.
                </li>
                <li className={styles.item}>
                  Администрация сайта – уполномоченные сотрудники на управление Сайтом,
                  действующие от имени {COMPANY_SELLER.name}.
                </li>
                <li className={styles.item}>
                  Пользователь сайта (далее Пользователь) – лицо, имеющее доступ к Сайту,
                  посредством сети Интернет и использующее Сайт.
                </li>
                <li className={styles.item}>
                  Содержание сайта (далее – Содержание) - охраняемые результаты
                  интеллектуальной деятельности, включая предисловия, аннотации, статьи,
                  иллюстрации, обложки, графические, текстовые,
                  фотографические, производные, составные и иные произведения, пользовательские
                  интерфейсы, визуальные интерфейсы, названия товарных знаков, логотипы,
                  программы для ЭВМ, базы данных, а также дизайн, структура, выбор, координация,
                  внешний вид, общий стиль и расположение данного Содержания, входящего в
                  состав Сайта и другие объекты интеллектуальной собственности все вместе
                  и/или по отдельности, содержащиеся на сайте.
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Использование сайта
          <ol className={styles.list}>
            <li className={styles.item}>
              Сайт и Содержание, входящее в состав Сайта, принадлежит и управляются
              Администрацией сайта.
            </li>
            <li className={styles.item}>
              Содержание Сайта не может быть скопировано, опубликовано, воспроизведено,
              передано или распространено любым способом, а также размещено в глобальной
              сети «Интернет» без предварительного письменного согласия Администрации сайта.
            </li>
            <li className={styles.item}>
              Содержание Сайта защищено авторским правом, законодательством о товарных
              знаках, а также другими правами, связанными с интеллектуальной собственностью,
              и законодательством о недобросовестной конкуренции.
            </li>
            <li className={styles.item}>
              Пользователь несет персональную ответственность за сохранение
              конфиденциальности информации учётной записи, включая пароль, а также за всю без
              исключения деятельность, которая ведётся от имени Пользователя учётной записи.
            </li>
            <li className={styles.item}>
              Пользователь должен незамедлительно уведомить Администрацию сайта о
              несанкционированном использовании его учётной записи или пароля или любом другом
              нарушении системы безопасности.
            </li>
            <li className={styles.item}>
              Администрация сайта обладает правом в одностороннем порядке аннулировать
              учётную запись Пользователя, если она не использовалась более 12 календарных месяцев
              подряд без уведомления Пользователя.
            </li>
            <li className={styles.item}>
              Информация, размещаемая на Сайте не должна истолковываться как изменение
              настоящего Соглашения.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Обязательства Пользователя
          <ol className={styles.list}>
            <li className={styles.item}>
              Пользователь соглашается не предпринимать действий, которые могут
              рассматриваться как нарушающие российское законодательство или нормы
              международного права, в том числе в сфере интеллектуальной
              собственности, авторских и/или смежных правах, а также любых действий,
              которые приводят или могут привести к нарушению нормальной работы Сайта
              и сервисов Сайта.
            </li>
            <li className={styles.item}>
              Использование материалов Сайта без согласия правообладателей не допускается
              (статья 1270 Г.К РФ). Для правомерного использования материалов Сайта
              необходимо заключение лицензионных договоров (получение лицензий) от
              Правообладателей.
            </li>
            <li className={styles.item}>
              При цитировании материалов Сайта, включая охраняемые авторские произведения,
              ссылка на Сайт обязательна (подпункт 1 пункта 1 статьи 1274 Г.К РФ).
            </li>
            <li className={styles.item}>
              Комментарии и иные записи Пользователя на Сайте не должны вступать в
              противоречие с требованиями законодательства Российской Федерации и общепринятых
              норм морали и нравственности.
            </li>
            <li className={styles.item}>
              Пользователь предупрежден о том, что Администрация Сайта не несет
              ответственности за посещение и использование им внешних ресурсов, ссылки
              на которые могут содержаться на сайте.
            </li>
            <li className={styles.item}>
              Пользователь согласен с тем, что Администрация Сайта не несет ответственности
              и не имеет прямых или косвенных обязательств перед Пользователем в связи
              с любыми возможными или возникшими потерями или убытками, связанными с
              любым содержанием Сайта, регистрацией авторских прав и сведениями о такой
              регистрации, товарами или услугами, доступными на или полученными через
              внешние сайты или ресурсы либо иные контакты Пользователя, в которые он
              вступил, используя размещенную на Сайте информацию или ссылки на внешние
              ресурсы.
            </li>
            <li className={styles.item}>
              Пользователь принимает положение о том, что все материалы и сервисы Сайта
              или любая их часть могут сопровождаться рекламой. Пользователь согласен с
              тем, что Администрация Сайта не несет какой-либо ответственности и не
              имеет каких-либо обязательств в связи с такой рекламой.
            </li>
            <li className={styles.item}>
              Пользователю запрещается:
              <ol className={styles.list}>
                <li className={styles.item}>
                  Использовать любые устройства, программы, процедуры, алгоритмы и
                  методы, автоматические устройства или эквивалентные ручные процессы
                  для доступа, приобретения, копирования или отслеживания содержания Сайта;
                </li>
                <li className={styles.item}>
                  Нарушать надлежащее функционирование Сайта;
                </li>
                <li className={styles.item}>
                  Любым способом обходить навигационную структуру Сайта для получения
                  или попытки получения любой информации, документов или материалов
                  любыми средствами, которые специально не представлены сервисами
                  данного Сайта;
                </li>
                <li className={styles.item}>
                  Несанкционированный доступ к функциям Сайта, любым другим системам
                  или сетям, относящимся к данному Сайту, а также к любым услугам,
                  предлагаемым на Сайте;
                </li>
                <li className={styles.item}>
                  Нарушать систему безопасности или аутентификации на Сайте или в любой
                  сети, относящейся к Сайту.
                </li>
                <li className={styles.item}>
                  Выполнять обратный поиск, отслеживать или пытаться отслеживать любую
                  информацию о любом другом Пользователе Сайта.
                </li>
                <li className={styles.item}>
                  Использовать Сайт и его Содержание в любых целях, запрещенных
                  законодательством Российской Федерации, а также подстрекать к любой
                  незаконной деятельности или другой деятельности, нарушающей права
                  Компании или других лиц.
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Прочие условия
          <ol className={styles.list}>
            <li className={styles.item}>
              Все возможные споры, вытекающие из настоящего Соглашения или связанные
              с ним, подлежат разрешению в соответствии с действующим
              законодательством Российской Федерации.
            </li>
            <li className={styles.item}>
              Ничто в Соглашении не может пониматься как установление между
              Пользователем и Администрации Сайта агентских отношений, отношений
              товарищества, отношений по совместной деятельности, отношений найма,
              либо каких-то иных отношений, прямо не предусмотренных Соглашением.
            </li>
            <li className={styles.item}>
              В случае возникновения любых разногласий или споров между Сторонами
              настоящего Соглашения обязательным условием до обращения в суд является
              предъявление претензии (письменного предложения о добровольном
              урегулировании спора).
            </li>
            <li className={styles.item}>
              Получатель претензии в течение 30 календарных дней со дня ее получения,
              письменно уведомляет заявителя претензии о результатах рассмотрения претензии.
            </li>
            <li className={styles.item}>
              При невозможности разрешить спор в добровольном порядке любая из
              Сторон вправе обратиться в суд за защитой своих прав, которые
              предоставлены им действующим законодательством Российской Федерации.
            </li>
            <li className={styles.item}>
              Признание судом какого-либо положения Соглашения недействительным
              или не подлежащим принудительному исполнению не влечёт недействительности
              иных положений Соглашения.
            </li>
            <li className={styles.item}>
              Бездействие со стороны Администрации Сайта в случае нарушения кем-либо
              из Пользователей положений Соглашения не лишает Администрацию Сайта
              права предпринять позднее соответствующие действия в защиту своих
              интересов и защиту авторских прав на охраняемые в соответствии с
              законодательством материалы Сайта. Пользователь подтверждает, что ознакомлен
              со всеми пунктами настоящего Соглашения и безусловно принимает их.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Нарушение условий пользовательского соглашения
          <ol className={styles.list}>
            <li className={styles.item}>
              Администрация сайта вправе раскрыть любую собранную о Пользователе
              данного Сайта информацию, если раскрытие необходимо в связи с
              расследованием или жалобой в отношении неправомерного использования
              Сайта либо для установления (идентификации) Пользователя, который может
              нарушать или вмешиваться в права Администрации сайта или в права других
              Пользователей Сайта.
            </li>
            <li className={styles.item}>
              Администрация сайта имеет право раскрыть любую информацию о Пользователе,
              которую посчитает необходимой для выполнения положений действующего
              законодательства или судебных решений, обеспечения выполнения условий
              настоящего Соглашения, защиты прав или безопасности Пользователей.
            </li>
            <li className={styles.item}>
              Администрация сайта имеет право раскрыть информацию о Пользователе,
              если действующее законодательство Российской Федерации требует или
              разрешает такое раскрытие.
            </li>
            <li className={styles.item}>
              Администрация сайта вправе без предварительного уведомления Пользователя
              прекратить и (или) заблокировать доступ к Сайту, если Пользователь
              нарушил настоящее Соглашение или содержащиеся в иных документах условия
              пользования Сайтом, а также в случае прекращения действия Сайта либо по
              причине технической неполадки или проблемы.
            </li>
            <li className={styles.item}>
              Администрация сайта не несет ответственности перед Пользователем или
              третьими лицами за прекращение доступа к Сайту в случае нарушения
              Пользователем любого положения настоящего Соглашения или иного документа,
              содержащего условия пользования Сайтом.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Ответственность
          <ol className={styles.list}>
            <li className={styles.item}>
              Любые убытки, которые Пользователь может понести в случае умышленного
              или неосторожного нарушения любого положения настоящего Соглашения,
              а также вследствие несанкционированного доступа к коммуникациям другого
              Пользователя, Администрацией сайта не возмещаются.
            </li>
            <li className={styles.item}>
              Администрация сайта не несет ответственности за:
              <ol className={styles.list}>
                <li className={styles.item}>
                  Задержки или сбои в процессе совершения операции, возникшие
                  вследствие непреодолимой силы, а также любого случая неполадок в
                  телекоммуникационных, компьютерных, электрических и иных смежных системах.
                </li>
                <li className={styles.item}>
                  Действия систем переводов, банков, платежных систем и за задержки
                  связанные с их работой.
                </li>
                <li className={styles.item}>
                  Надлежащее функционирование Сайта, в случае, если Пользователь не
                  имеет необходимых технических средств для его использования, а
                  также не несет никаких обязательств по обеспечению пользователей
                  такими средствами.
                </li>
              </ol>
            </li>

          </ol>
        </li>
      </ol>
    </main>
  );
}

export default Agreement;
